import { filterSingle_multiLevel_selector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { sidebarMenu_template } from "../templates/sidebarMenu_template";

declare var ko: any;

export class accountSettings_template extends vnTemplate {

    public sidebarMenu: sidebarMenu_template;
    public propertyDropdown: filterSingle_multiLevel_selector_template;


    protected getTemplateHtml(): string {

        return `

        <div class="page-header">
            <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
            <h2 style="display: none;" class="title-page">Account Settings</h2>
        </div>

        <div class="nav-page-container">
            <div class="nav-page-grid">
                <div class="nav-page-sidebar">
                    ` + this.sidebarMenu.getHtmlBuild() + `
                </div>
                <div class="nav-page-content">
                    <div class="block-default variation">
                        <div class="w-justify full-width">
                            <div class="w-left w-form">
                                <div class="form-body form-body-header">
                                    <div class="form-group">
                                        <span class="form-sub-title">
                                            Manage your account settings.
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <p class="form-text">
                                            View your account name, account owner, and subscription plan here. Stay tuned for more features in future updates.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="w-right">

                            </div>
                        </div>
                    </div>

                    <div class="w-form w-form-large">
                        <div class="form-header" style="height: 2rem;">

                        </div>
                        <div class="w-form-body">
                            <div class="form-body">
                                <span class="form-sub-title">Account Details</span>
                                <div class="form-group">
                                    <label for="accountName" class="form-label">Account Name</label>
                                    <input id="accountName" readonly="true" data-bind="value: accountName, attr: {readOnly: disabledAccountName}" type="text" class="input-text read-only">
                                </div>
                                <div class="form-group">
                                    <label for="accountUser" class="form-label">Account User</label>
                                    <input id="accountUser" readonly="true" data-bind="value: accountUser, attr: {readOnly: disabledAccountUser}" type="text" class="input-text read-only">
                                </div>
                                <div class="form-group">
                                    <label for="accountPlan" class="form-label">Account Plan</label>
                                    <input id="accountPlan" readonly="true" data-bind="value: accountPlan, attr: {readOnly: disabledPlan}" type="text" class="input-text read-only">
                                </div>
                            </div>
                            <div class="form-body">
                                <span class="form-sub-title">Your Sentinel Tracking Code</span>
                                <div class="form-group">
                                    <p class="form-text">To start tracking analytics, you'll need to install our tracking pixel on your website. Please find your unique pixel code and installation instructions below:</p>
                                </div>
                                <div class="form-group block-filters">

                                    ` + this.propertyDropdown.getHtmlBuild() + `

                                    <span class="code">
                                        <pre>
                                            <code data-bind="text: pixelCode()"></code>
                                        </pre>
                                    </span>
                                    <button class="button-default icon i-copy" data-bind="click: copyPixelCodeToClipboard">copy code</button>
                                </div>
                                <div class="form-group">
                                    <ol>
                                        <li>Copy the pixel code above.</li>
                                        <li>Paste it into the &lt;head&gt; section of your website's HTML.</li>
                                        <li>Save and publish the changes.</li>
                                    <ol>

                                </div>

                                <div class="form-group">
                                    <p class="form-text"><strong>That's it!</strong> Your SentinelPro dashboards will begin displaying data within a few minutes to a couple of hours after installing Sentinel JS.</p>
                                </div>
                                <div class="form-group frame">
                                    <p class="form-text">Need help?<br>Contact our support team for assistance<br>
                                    <a style="width: fit-content;" href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                                </div>
                            </div>
                        </div>
                        <div style="height: 50px;" class="form-footer">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer class="default-footer">
            <span class="logo-short"></span>
            <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
            <span>|</span>
            <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
        </footer>
        `;
    }

    protected initPartial(): void {

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('account-settings');

        this.propertyDropdown = new filterSingle_multiLevel_selector_template('propertyDropdown', this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{

        return "accountSettings-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["page-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            accountName: ko.observable(""),
            accountUser: ko.observable(""),
            accountPlan: ko.observable(""),
            accountProperties: ko.observable([]),
            timeFormat: ko.observable(""),
            disabledAccountName: ko.observable(true),
            disabledAccountUser: ko.observable(true),
            disabledPlan: ko.observable(true),
            disabledTimeFormat: ko.observable(true),
            sidebarToggle: ko.observable(false),
            pixelCode: ko.observable(''),
            openSidebar: function(){
                self.openSidebar();
            },
            copyPixelCodeToClipboard: function(){
                self.copyPixelCodeToClipboard();
            }
        };
    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest(){

        return {
            selectedProperty: this.propertyDropdown.getSelectedOption()
            ,roleFilter: this.getTemplateViewModel().roleFilter
        }
    }

    public setFormData(data){

        this.getTemplateViewModel().accountName(data.accountName);
        this.getTemplateViewModel().accountUser(data.accountUser);
        this.getTemplateViewModel().accountPlan(data.accountPlan);
        this.getTemplateViewModel().accountProperties(data.accountProperties);

        this.propertyDropdown.setGroups(data.accountProperties.map(p => {

            return {
                id: p.id,
                name: p.name,
                type: '',
                cssClasses: ''
            }
        }));

        this.caller.filterSingleGroupSelectorOnChange();
    }

    public copyPixelCodeToClipboard(){
        const pixelCode = this.getTemplateViewModel().pixelCode();

        navigator.clipboard.writeText(pixelCode);
        this.caller.copyToClipboardNotification();
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/accountSettings_template.ts